import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { CHANNEL_TYPES, API_RESPONSE_CODES, DEVICE_CODE, VASCO_MODAL_TYPES, ECREDENTIALS, FORGOT_PASSWORD_FLOW_STEPS } from '../constants';
import Guid from '../utils/guid';
import isValidJsonString from '../utils/is-valid-json-string';
import { encode } from 'base-64';
import { Base64 } from 'js-base64';

const ECREDENTIALS_PATH = 'roster.data.auth';


export default () => {
  return muster()
    .path('forgotPassword.initiateResetPassword', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const [langCode] = await getValues(get('auth.langCode'));
        //  TO DO :: Optimization to be done
        let selectedLangCode = 'en';
        if (langCode === 'en') {
          selectedLangCode = 'en-GB';
        }

        if (langCode === 'de') {
          selectedLangCode = 'DE-CH';
        }

        await set('forgotPassword.errorText', false);
        await call('forgotPassword.setAttemptCount', null, null);

        const request = {
          userId: req.args[0],
          emailId: req.args[1],
          deviceCode: DEVICE_CODE,
          language: selectedLangCode,
          channel: CHANNEL_TYPES.WEB
        }
        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;

        await set('forgotPassword.loading', true);
        const [result] = await
          getValues(
            get(`${ECREDENTIALS_PATH}.initiateResetPassword["${inputParam}"]["${guidStr}"]`)
          );

        isValidJsonString(result).then(async (data) => {
          if (data) {
            const returnCode = data.returnCode.toString();
            await set('forgotPassword.initiateResetPasswordResponse', data);
            if (returnCode === API_RESPONSE_CODES.SUCCESS) {
              await Promise.all([
                set('rsa.rsaAuthorised', false),
                //  set('auth.authorised', true),
                set('forgotPassword.showCurrentStep', FORGOT_PASSWORD_FLOW_STEPS[1]),
                set('forgotPassword.initiateResetPwdResultValid', true),
                // set('vascoauthentication.vascoVisible', true),
                // set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.pin2fa),
                set('auth.authHeader', data.jwt),
                set('forgotPassword.loading', false)
                // "vascoauthentication.otpStatus"
              ]);
              // set('vascoauthentication.vascoAuthorised', true),
              // if (vascoLoginType === VASCO_FLOW.browser && vascoAuthvalue === undefined || vascoAuthvalue === false) {
              //  set('vascoauthentication.vascoVisible', true);
              // }
              //  await call('vascoauthentication.showVascoModal', VASCO_MODAL_TYPES.pin2fa);
              return;
            }
           
            if (returnCode === API_RESPONSE_CODES.INVALID_USERNAME_AND_EMAILID) {
              await Promise.all(
                [set('forgotPassword.errorText', true),
                set('forgotPassword.errorMessage', messages['app.forgotPassword.initiateResetPasswordError']),
                set('forgotPassword.loading', false),
                set('auth.userId', ''),
                set('auth.emailId', ''),
                ]);
              await call('forgotPassword.setAttemptCount', data.attemptCount, data.maxCount);
              return;
            }

            if (returnCode === API_RESPONSE_CODES.VASCO_ELIGIBILITY_CHECK) {
              await Promise.all(
                [set('forgotPassword.errorText', true),
                set('forgotPassword.errorMessage', messages['app.forgotPassword.initiateResetPasswordError']),
                set('forgotPassword.loading', false),
                set('auth.userId', ''),
                set('auth.emailId', ''),
                ]);
              await call('forgotPassword.setAttemptCount', data.attemptCount, data.maxCount);
              return;
            }

            if (returnCode === API_RESPONSE_CODES.ERGON_API_INITIATE_FAILURE) {
              await Promise.all(
                [set('forgotPassword.errorText', true),
                set('forgotPassword.errorMessage', messages['app.forgotPassword.initiateResetPasswordError']),
                set('forgotPassword.loading', false),
                set('auth.userId', ''),
                set('auth.emailId', ''),
                ]);
              await call('forgotPassword.setAttemptCount', data.attemptCount, data.maxCount);
              return;
            }

            if (returnCode === API_RESPONSE_CODES.ERROR_MAX_COUNT) {
              await Promise.all(
                [
                  set('forgotPassword.errorText', true),
                  set('forgotPassword.errorMessage', messages['app.forgotPassword.passwordVirtuallyLocked']),
                  set('forgotPassword.loading', false),
                  set('auth.userId', ''),
                  set('auth.emailId', ''),
                ]);
              await call('forgotPassword.setAttemptCount', '', '');
              return;
            }
            // generic message
            await Promise.all(
              [set('forgotPassword.loading', false),
              set('forgotPassword.errorText', true),
              set('forgotPassword.errorMessage', messages['app.forgotPassword.genericError']),
              // set('forgotPassword.blurModalError', true),
              ]
            );
          }
        }).catch(async (error) => {
          await Promise.all(
            [set('forgotPassword.loading', false),
            set('forgotPassword.errorText', true),
            set('forgotPassword.errorMessage', messages['app.forgotPassword.genericError']),
            // set('forgotPassword.blurModalError', true)
          ]
          );
        });
      }
    })

    .path('forgotPassword.generateTempPassword', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));

        const request = {
          userId: req.args[0],
          emailId: req.args[1]
        }

        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;

        const [result] = await
          getValues(
            get(`${ECREDENTIALS_PATH}.generateTempPassword["${inputParam}"]["${guidStr}"]`)
          );

        isValidJsonString(result).then(async (data) => {
          if (data) {
            const returnCode = data.returnCode.toString();
            await set('forgotPassword.generateTempPasswordResponse', data);
            // await call('vascoauthentication.hideVasco');
            if (returnCode === API_RESPONSE_CODES.SUCCESS) {
              await Promise.all([
                set('forgotPassword.generateTempPwdResultValid', true),
                set('forgotPassword.loading', false)])
            }
            else if (returnCode === API_RESPONSE_CODES.ERROR_IN_EMAIL_SERVICE) {
              await Promise.all(
                [set('forgotPassword.loading', false),
                set('forgotPassword.generateTempPwdResultValid', false),
                set('forgotPassword.blurModalError', false)]
              )
            }
            else if (returnCode === API_RESPONSE_CODES.ERROR) {
              await set('forgotPassword.blurModalError', true);
              await set('forgotPassword.generateTempPwdResultValid', false);
              await call('forgotPassword.setAttemptCount', data.attemptCount, data.maxCount)
            }
            else {
              // generic message
              await Promise.all(
                [set('forgotPassword.loading', false),
                set('forgotPassword.generateTempPwdResultValid', false),
                set('forgotPassword.blurModalError', true)]
              );
            }
          }
        }).catch(async (error) => {
          await Promise.all(
            [set('forgotPassword.loading', false),
            set('forgotPassword.generateTempPwdResultValid', false),
            set('forgotPassword.blurModalError', true)]
          );
        });
      }
    })

    .path('forgotPassword.updateECredStatus', {
      call: async ({ req }, { get, set, call }) => {
        const [messages] = await getValues(get('i18n.messages'));
        const [userId] = await getValues(get(['auth.userId']));
        const request = {
          userId: userId,
          moduleId: ECREDENTIALS.EPWD_RESET_STATUS,
          status: req.args[0] || '',
        }

        const requestObj = Base64.encode(JSON.stringify(request));
        const guidStr = Guid();
        const inputParam = `${requestObj}`;

        const [result] = await
          getValues(
            get(`${ECREDENTIALS_PATH}.updateECredStatus["${inputParam}"]["${guidStr}"]`)
          );

        isValidJsonString(result).then(async (data) => {
          if (data) {
            const returnCode = data.returnCode.toString();
            if (returnCode === API_RESPONSE_CODES.SUCCESS) {
              await set('auth.eCredPwd', null);
            }
            if (returnCode === API_RESPONSE_CODES.ERROR) {
              // TO DO ::
            }
          }
          else {
            // generic message
            await Promise.all(
              [set('forgotPassword.loading', false),
              set('forgotPassword.blurModalError', true)]
            );
          }
        }).catch(async (error) => {
          await Promise.all(
            [set('forgotPassword.loading', false),
            set('forgotPassword.blurModalError', true)]
          );
        });
      }
    })

    .path('forgotPassword.setAttemptCount', {
      call: async ({ req }, { set }) => {
        set('forgotPassword.wrongResetPwdAttemptCount', req.args[0]);
        set('forgotPassword.attemptCountHasExceeded', req.args[1]);
      }
    })

    .path('forgotPassword.resetVariables', {
      call: async ({ _ }, { set }) => {
        await Promise.all([
          //  TO BE CONFIRMED
          set('auth.userId', ''),
          set('auth.emailId', ''),
          set('forgotPassword.loading', false),
          set('forgotPassword.showCurrentStep', FORGOT_PASSWORD_FLOW_STEPS[0]),
          set('forgotPassword.generateTempPwdResultValid', false),
          set('forgotPassword.verifyOTPForForgotPassword', false),
          set('forgotPassword.verifyOTPForForgotPasswordSuccess', false),
          set('forgotPassword.errorText', null),
          set('forgotPassword.errorMessage', ''),
          // set('forgotPassword.wrongResetPwdAttemptCount', null),
          // set('forgotPassword.attemptCountHasExceeded', null),
          // set('forgotPassword.blurModalError', false),
          // set('forgotPassword.expiredPassword', false),
          // set('forgotPassword.incorrectPassword', false)
        ]);
      }
    })

    .path('auth.eCredPwd', variable(null))
    .path('auth.emailId', variable(''))
    .path('auth.changePasswordForECred', variable(null))
    .path('forgotPassword.loading', variable(null))
    .path('forgotPassword.initiateResetPasswordResponse', variable(null))
    .path('forgotPassword.initiateResetPwdResultValid', variable(false))
    .path('forgotPassword.generateTempPasswordResponse', variable(null))
    .path('forgotPassword.generateTempPwdResultValid', variable(false))
    .path('forgotPassword.errorText', variable())
    .path('forgotPassword.showforgotPassword', variable(false))
    .path('forgotPassword.wrongResetPwdAttemptCount', variable())
    .path('forgotPassword.attemptCountHasExceeded', variable())
    .path('forgotPassword.setLoading', variable(false))
    .path('forgotPassword.isforgotPasswordAfterLogin', variable(false))
    .path('forgotPassword.blurModalError', variable(false))
    .path('forgotPassword.isTempPwdGenerated', variable(false))
    .path('forgotPassword.isTempPwdGeneratedError', variable(false))
    .path('forgotPassword.showForgotPasswordPage', variable(false))
    .path('forgotPassword.verifyOTPForForgotPassword', variable(false))
    .path('forgotPassword.verifyOTPForForgotPasswordSuccess', variable(false))
    .path('forgotPassword.isForgotPwdAfterLogin', variable(false))
    .path('forgotPassword.showForgotPwd', variable(false))
    .path('forgotPassword.expiredPassword', variable(false))
    .path('forgotPassword.incorrectPassword', variable(false))
    .path('forgotPassword.noPasswordFound', variable(false))
    .path('forgotPassword.errorMessage', variable(''))
    .path('forgotPassword.showCurrentStep', variable(FORGOT_PASSWORD_FLOW_STEPS[0]))
}
